"use client";

import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import ButtonActionSvg from "~/assets/images/button-action-icon.svg?react";

import PhoneCountrySelect from "./PhoneCountrySelect";
import styles from "./PhoneInputButton.module.scss";

export default function PhoneInputButton({
  locale,
  country,
  onCountryChange,
  placeholder,
  label,
  className,
  value,
  onChange,
  onSubmit,
  disabled,
  inputProps,
  buttonProps,
  searchPlaceholder,
  emptyLabel,
}) {
  const { t } = useTranslation();
  const resolvedSearchPlaceholder = searchPlaceholder ?? t("common.phoneCountrySelect.searchPlaceholder");
  const resolvedEmptyLabel = emptyLabel ?? t("common.phoneCountrySelect.emptyLabel");

  return (
    <div className={clsx(styles.root, className)}>
      <PhoneCountrySelect
        locale={locale}
        country={country}
        onCountryChange={onCountryChange}
        disabled={disabled}
        searchPlaceholder={resolvedSearchPlaceholder}
        emptyLabel={resolvedEmptyLabel}
      />
      <input
        placeholder={placeholder}
        type="tel"
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...inputProps}
      />
      <button
        className={clsx("variant-scale show-md", styles.actionButton)}
        onClick={onSubmit}
        disabled={disabled}
        {...buttonProps}
      >
        {label}
      </button>
      <button
        className={clsx("variant-scale show-sm", styles.actionButton)}
        onClick={onSubmit}
        disabled={disabled}
        {...buttonProps}
      >
        <div>
          <ButtonActionSvg />
        </div>
      </button>
    </div>
  );
}
